import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const PackagesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الباقات",
				breadcrumb: "الباقات",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة باقة جديدة",
					link: "/packages/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/package/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				{data.map(item =>
					item.categories.map(category =>
						category.posts.map(post => (
							<div key={post.id} className="col-md-4">
								<div className="package">
									<h4>
										<Link
											to={
												checkPermissions(["post-edit"])
													? `/packages/show/${post.id}`
													: "/"
											}
										>
											{post.data.title}
										</Link>
									</h4>
									<ul className="list-unstyled">
										{post.data.points.map(point => (
											<li>{point}</li>
										))}
									</ul>
									{checkPermissions(["post-delete"]) && (
										<button
											onClick={() => handleDelete(post.id)}
											className="bt bt-danger btn-block"
											aria-label="حذف الباقة"
										>
											<i className="fas fa-trash"></i>
										</button>
									)}
								</div>
							</div>
						))
					)
				)}
			</div>
		</section>
	);
};

export default PackagesIndex;
